var __jsx = React.createElement;
import React from 'react';
import { ContentWrapper, LoaderMessage, LoaderWrapper, PlayerLoader } from './Wrapper';

var Loader = function Loader(_ref) {
  var color = _ref.color,
      message = _ref.message,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? true : _ref$transparent;
  return __jsx(LoaderWrapper, null, __jsx(ContentWrapper, null, __jsx(PlayerLoader, {
    transparent: transparent
  }, __jsx("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("path", {
    d: "M43 43C43 19.804 24.196 1 1 1",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round"
  }))), message && __jsx(LoaderMessage, null, message)));
};

export default Loader;